module.exports = __webpack_public_path__ + "assets/img/aiqfome.18ebacd5.svg";